import {SmartComponentManager} from "smart-component-js";
import DefaultCtrl from "./controllers/DefaultCtrl";
import FeedbackModalComponent from "./components/FeedbackModalComponent";
import ProductsComponent from "./components/ProductsComponent";
import VisualParallaxComponent from "./components/VisualParallaxComponent";
import AreaPersonaleCtrl from "./controllers/AreaPersonaleCtrl";
import ModificaDatiCtrl from "./controllers/ModificaDatiCtrl";
import $ from "jquery";
import '../less/mb-promo.less';
import SurveyCtrl from "./controllers/SurveyCtrl";


SmartComponentManager.registerComponents({
	DefaultCtrl,
	VisualParallaxComponent,
	FeedbackModalComponent,
	ProductsComponent,
	AreaPersonaleCtrl,
	ModificaDatiCtrl,
	SurveyCtrl
});

$(document).ready(() => {
	let $body = $('.mb-promo');
	SmartComponentManager.initComponentByName($body[0], $body.attr('component'));
});
